import { streetApi } from "src/config/axios";
import type { AxiosError } from "axios";
import { mutate } from "swr";
import customError from "./customError";

const toggleEventBookMarks = async (
    eventId: number,
    handelSetOperatedBookmarkList: (eventId: number, isLikes: boolean) => void
) => {
    return streetApi
        .post(`/events/${eventId}/toggle-bookmark`)
        .then((response) => {
            const massage = response.data.message;
            switch (massage) {
                case "ブックマークを追加しました。":
                    handelSetOperatedBookmarkList(eventId, true);
                    break;
                case "ブックマークを削除しました。":
                    handelSetOperatedBookmarkList(eventId, false);
                    break;
                default:
                    break;
            }
            // カレンダーのキャッシュを再検証
            mutate("/calendar");
        })
        .catch((error: AxiosError) => {
            const errorMessage = (error.response?.data as { message: string })
                ?.message;
            throw customError(errorMessage);
        });
};

export default toggleEventBookMarks;
